module.exports = __webpack_public_path__ + "img/ratemds.03651915.png";